<template>
  <div class="searchHome">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="content_bar">
      <div class="search_header search">
        <!-- 搜索框 -->
        <div class="search" ref="searchContainer">
          <div class="search_box" :class="isFocused ? 'search_focus_box' : ''">
            <div class="search_icon" :class="isFocused ? 'search_focus_box_sel' : ''"></div>
            <input v-model.trim="serchValue" @focus.stop="onFocus" class="search_input" type="text"
              placeholder="请输入想找的游戏关键词">
            <div class="del_val" v-if="serchValue" @click.stop="() => { serchValue = '' }"></div>
            <div v-if="isFocused" @click.stop="handelSearch" class="search_btn">搜索</div>
          </div>
        </div>
        <!-- 历史记录&热门搜索 -->
        <div v-if="isFocused" class="pane_overlay" ref="paneOverlay">
          <!-- 热门推荐&历史搜索记录 -->
          <div v-if="isFocused && !serchValue" class="search_pane">
            <div>
              <!-- 搜索记录--操作 -->
              <div class="history_box" v-if="historyList && historyList.length > 0">
                <img class="pane_title" src="@/assets/image/history_icon.png" alt="">
                <div class="clear_box">
                  <img class="clear_icon" src="@/assets/image/search_close_ic.png" alt="">
                  <span class="clear_text" @click.stop="clearAllHistory">删除</span>
                </div>
              </div>
              <!-- 搜索记录 -->
              <div class="history_list" v-if="historyList && historyList.length > 0">
                <div class="history_item" v-for="(item, index) in historyList" :key="'history' + index">
                  <div class="item_text" @click="historySearch(item)">{{ item }}</div>
                </div>
              </div>
              <!-- 推荐游戏 -->
              <div class="hot_box">
                <img class="pane_title" src="@/assets/image/hot_icon.png" alt="">
              </div>
              <!-- 推荐游戏 -->
              <div class="hot_search_list">
                <div class="hot_list left_box" v-if="hot_ser_left_list && hot_ser_left_list.length > 0">
                  <div class="hot_item" @click.stop="checkGameDes(hotLeftItem.gid)"
                    v-for="(hotLeftItem, index) in hot_ser_left_list" :key="'hotLeftItem' + index">
                    <div class="left_box">
                      <div class="sort_num"
                        :class="index == 0 ? 'one' : index == 1 ? 'two' : index == 2 ? 'there' : ''">
                        {{ index + 1 }}</div>
                      <div class="game_name">{{ hotLeftItem.show_name ? hotLeftItem.show_name : hotLeftItem.game_name }}
                      </div>
                      <div class="mark"
                        :class="hotLeftItem.flag == 2 ? 'r' : hotLeftItem.flag == 3 ? 'h' : hotLeftItem.flag == 1 ? 'b' : ''">
                        {{ hotLeftItem.flag
                          == 2 ? '荐' : hotLeftItem.flag == 3 ? '热' : hotLeftItem.flag == 1 ? '新' : '' }}</div>
                    </div>
                    <div class="search_times_box">
                      <span>热度：</span>
                      <div class="search_times">{{ hotLeftItem.hot_count }}</div>
                    </div>
                  </div>
                </div>
                <div class="hot_list right_box" v-if="hot_ser_right_list && hot_ser_right_list.length > 0">
                  <div class="hot_item" @click.stop="checkGameDes(hotRighrItem.gid)"
                    v-for="(hotRighrItem, index) in hot_ser_right_list" :key="'hotRighrItem' + index">
                    <div class="left_box">
                      <div class="sort_num">{{ hot_ser_left_list.length + index + 1 }}</div>
                      <div class="game_name">{{ hotRighrItem.show_name ? hotRighrItem.show_name : hotRighrItem.game_name
                        }}
                      </div>
                    </div>
                    <div class="search_times_box">
                      <span>热度：</span>
                      <div class="search_times">{{ hotRighrItem.hot_count }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 检索内容 -->
          <div v-if="serchValue" class="input_list">
            <div v-loading="loading">
              <div v-show="search_preview && search_preview.length > 0 && !loading">
                <div @click.stop="checkGameDes(serachItem.gid)" class="input_item"
                  v-for="(serachItem, index) in search_preview" :key="'serachItem' + index">
                  <img class="search_icon" src="@/assets/image/search.png" alt="">
                  <span class="input_text"> {{ serachItem.show_name ? serachItem.show_name : serachItem.game_name
                    }}</span>
                </div>
              </div>
              <div v-show="search_preview && search_preview.length == 0" class="empty_box">
                <img class="empty_icon" src="@/assets/image/search_empty.png" alt="">
                没有搜索到游戏 换个关键词试试吧~
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Bus from '@/util/Bus'
import { mapState } from "vuex";
import { postData } from '@/api/api.js'
import { debounce } from "@/util/util";

export default {
  name: 'searchNav',
  components: {
    // HelloWorld
  },
  data() {
    return {
      loading: false,
      isFocused: false,
      serchValue: '',
      historyList: [],//搜索记录
      hot_ser_left_list: [],//推荐热门游戏
      hot_ser_right_list: [],//推荐热门游戏
      search_preview: [],//搜索预览游戏
    }
  },
  created() {
    this.get_by_rank()
    const stored = window.localStorage.getItem("historyList");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.historyList = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        this.historyList = [];
      }
    } else {
      this.historyList = [];  // 直接赋值即可，无需 $set
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  computed: {
    ...mapState(["uid", "requestParams", "search_num", "platform",]),
  },
  watch: {
    serchValue(n) {
      if (n.length > 0) {
        this.get_search_preview();
      }
      if (n.length < 1) {
        this.search_preview = [];
      }
      // if (n.length === 0) this.$router.replace({ query: {} }) // 清空url参数
    },
  },
  methods: {
    reset() {
      this.search_preview = []//搜索预览游戏
      this.isFocused = false
      this.serchValue = ''
    },
    handleOutsideClick(event) {
      const searchContainer = this.$refs.searchContainer;
      const paneOverlay = this.$refs.paneOverlay;

      // 如果点击的目标在搜索框容器内 或 在弹层内，则不关闭
      if (searchContainer?.contains(event.target) || paneOverlay?.contains(event.target)) {
        return;
      }
      // 否则关闭弹层并清空搜索词
      this.isFocused = false;
      this.serchValue = '';
    },
    onFocus() {
      this.isFocused = true
    },
    onBlur() {
      console.log(8888)
      this.isFocused = false
      this.serchValue = ''
    },
    // 热门搜索
    async get_by_rank() {
      const params = {
        uid: this.uid, // 用户id
        lid: this.requestParams.lid, // 包链接id
        id: 4,
        subchannelnum: this.requestParams.subchannelnum, //广告商分包id
        platform: this.platform,
      };
      const res = await postData("/box/by-rank", params);
      if (res?.code === 0) {
        const data = res.data || [];
        const len = data.length;

        if (len <= 4) {
          // 长度 ≤ 4：全部给左边，右边为空
          this.hot_ser_left_list = data;
          this.hot_ser_right_list = [];
        } else {
          // 长度 > 4：最多取前 10 个，然后平分（奇数时左边多一个）
          const maxLen = Math.min(len, 10);
          const limitedData = data.slice(0, maxLen);
          const half = Math.ceil(maxLen / 2); // 左半部分长度（向上取整）
          this.hot_ser_left_list = limitedData.slice(0, half);
          this.hot_ser_right_list = limitedData.slice(half);
        }
        // this.hot_ser_right_list = res.data
      }
    },
    async historySearch(keyword) {
      const params = {
        uid: this.uid, // 游戏id
        lid: this.requestParams.lid, // 包链接id
        keyword: keyword,
        subchannelnum: this.requestParams.subchannelnum, //广告商分包id
      };
      const res = await postData("/box/search", params);
      if (res?.code === 0) {
        if (res?.data?.game.length > 0) {
          this.$router.replace({
            path: '/gameDetail',
            query: { id: res?.data?.game[0]?.gid, Date: new Date().getTime() }
          })
        } else {
          this.$router.push({
            path: '/gameEmpty',
          })
        }
        this.reset()
        console.log(res.data.game)
      }
    },
    // 搜索预览
    get_search_preview: debounce(
      async function () {
        this.loading = true
        const params = {
          uid: this.uid, // 游戏id
          lid: this.requestParams.lid, // 包链接id
          keyword: this.serchValue,
          subchannelnum: this.requestParams.subchannelnum, //广告商分包id
        };
        const res = await postData("/box/search", params);
        if (res.code === 0) {
          this.loading = false
          this.search_preview = res.data.game;
        }
      },
      450,
      false
    ),
    // 删除搜索记录
    clearAllHistory() {
      this.historyList = [];
      window.localStorage.setItem('historyList', JSON.stringify([]));
    },
    // 保留搜索记录
    handelSearch() {
      if (!this.serchValue) return; // 空值不记录
      // 跳转云游戏
      let values = {};
      let match = this.serchValue.match(/testCloudGame:gid=(\d+)&testCode=([^\s&]+)/);
      if (match) {
        values.gid = match[1];
        values.testCode = match[2];
        if (this.$route.path != "/gameDetail") {
          this.toPage("/gameDetail", { id: values.gid });
        }
        setTimeout(() => {
          Bus.$emit("testCode", values.testCode);
        }, 1000);
        return
      }
      let historyListArr = [];
      const stored = window.localStorage.getItem("historyList");
      if (stored) {
        try {
          historyListArr = JSON.parse(stored);
          // 确保解析结果是数组
          if (!Array.isArray(historyListArr)) historyListArr = [];
        } catch (e) {
          historyListArr = [];
        }
      }

      // 去重：如果已存在相同词，先移除旧的
      const index = historyListArr.indexOf(this.serchValue);
      if (index !== -1) historyListArr.splice(index, 1);
      // 新词插入到数组最前面
      historyListArr.unshift(this.serchValue);
      // 限制最多保存 10 条
      if (historyListArr.length > 10) historyListArr.pop();

      // 存储
      window.localStorage.setItem("historyList", JSON.stringify(historyListArr));
      // 更新组件内的数据
      this.historyList = historyListArr;
      // 跳转游戏详情
      if (this.search_preview.length > 0) {
        this.checkGameDes(this.search_preview[0].gid)
      } else {
        this.reset()
        this.$router.push({
          path: '/gameEmpty',
        })
      }
    },
    checkGameDes(id) {
      this.reset()
      this.$router.push({
        path: '/gameDetail',
        query: { id: id, Date: new Date().getTime() }
      })
    },
    toPage(path, query = {}) {
      this.$router.push({
        path: path,
        query: query,
      });
    },
  }
}
</script>

<style lang="less" scoped>
.searchHome {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 999;

}

.content_bar {
  height: 80px;
  width: 672px;
  z-index: 300;
  padding: 20px 32px;
  box-sizing: border-box;
  background: #ffffff;
  z-index: 21;

  .search_header {
    position: relative;

    .search_focus_box {
      position: relative;
      background: #f5f5ff;
      border: 1px solid #FF3838;
      padding-left: 15px;
      z-index: 999;
    }

    .search_focus_box_sel {
      background-image: url("@/assets/image/search_sel.png") !important;
    }

    // 索索框
    .search {
      display: flex;
      align-items: center;

      .search_box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;
        flex: 1;
        height: 40px;
        border-radius: 20px;
        background: #f5f5f5;
        padding: 6px 26px 6px 16px;
        font-weight: 400;
        box-sizing: border-box;

        .search_icon {
          width: 40px;
          height: 40px;
          background-image: url("@/assets/image/search.png");
          background-repeat: no-repeat;
          background-position: center;
          z-index: 10;
        }

        .search_input {
          flex: 1;
          height: 100%;
          background-color: transparent;
          padding: 0 40px 0 0;
          box-sizing: border-box;

          &::placeholder {
            color: rgba(0, 0, 0, .3);
          }

        }

        .del_val {
          width: 12px;
          height: 12px;
          background-image: url('@/assets/image/reserve_cancel_ic.png');
          background-size: cover;
          margin: 3px 10px 0 0;
          cursor: pointer;
          z-index: 6;
        }

        .search_btn {
          font-size: 16px;
          color: #FF3838;
          cursor: pointer;
          z-index: 6;
        }

      }
    }

    // 搜索弹出层
    .pane_overlay {
      display: flex;
      // display: none;
      position: absolute;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100%;
      background: transparent;
      // z-index: 20;
      z-index: -1;

      .search_pane {
        // display: none;
        z-index: 999;
        width: 100%;
        background: #ffffff;
        box-shadow: 0 0 40px rgba(0, 0, 0, .1);
        border-radius: 24px;
        box-sizing: border-box;
        position: absolute;
        top: 56px;
        left: 0;
        padding: 24px 30px 16px 22px;

        .history_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
          height: 24px;
          padding: 0 0 16px 8px;

          .pane_title {
            width: 74px;
            height: auto;
            object-fit: contain;
            display: block;
          }

          .clear_box {
            flex-shrink: 1;
            min-width: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-direction: row;
            font-size: 12px;
            font-weight: 400;
            color: #999;
            line-height: 16px;
            cursor: pointer;

            .clear_icon {
              flex-shrink: 0;
              width: 16px;
              height: 16px;
              display: block;
              padding-right: 4px;
            }

            .clear_text {
              flex-shrink: 1;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }

        .history_list {
          max-height: 86px;
          overflow: hidden;
          margin: 0 0 28px 8px;
          display: flex;
          align-items: stretch;
          justify-content: flex-start;
          flex-direction: row;
          flex-wrap: wrap;

          .history_item {
            padding: 0 14px 14px 0;

            .item_text {
              max-width: 240px;
              background: #f5f5f5;
              border-radius: 20px;
              font-size: 14px;
              font-weight: 400;
              color: #666;
              line-height: 20px;
              padding: 8px 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            }
          }
        }

        .hot_box {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-direction: row;
          height: 24px;
          padding: 0 0 12px 8px;

          .pane_title {
            width: 74px;
            height: auto;
            object-fit: contain;
            display: block;
          }
        }

        .hot_search_list {
          display: flex;
          align-items: stretch;
          justify-content: space-between;
          flex-direction: row;
          width: 100%;

          .left_box {
            padding-right: 20px;
            width: 100%;
          }

          .right_box {
            width: 100%;
          }

          .hot_list {
            .hot_item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex-direction: row;
              width: 100%;
              height: 36px;
              font-weight: 400;
              text-align: center;
              border-radius: 8px;
              margin-bottom: 10px;
              cursor: pointer;

              &:hover {
                background-color: rgba(0, 0, 0, .1);
              }

              .left_box {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-direction: row;
                flex: 1;
                padding-left: 10px;

                .sort_num {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: row;
                  width: 18px;
                  color: #999;
                  font-size: 14px;
                  font-weight: 700;
                  line-height: 20px;
                  text-align: center;
                }

                .one {
                  color: #FF3838;

                }

                .two {
                  color: #FF6523;

                }

                .there {
                  color: #FFD338;
                }

                .game_name {
                  max-width: 118px;
                  font-size: 14px;
                  line-height: 20px;
                  padding: 0 6px 0 12px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .mark {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 16px;
                  height: 16px;
                  font-size: 10px;
                  border-radius: 4px;
                  color: #ffffff;
                }

                .h {
                  background-color: #FF6523;
                }

                .r {
                  background-color: #FF3838;
                }

                .b {
                  background-color: #4A6AFF;
                }
              }

              .search_times_box {
                display: flex;
                align-items: center;
                font-size: 11px;
                color: #777C83;

                span {
                  white-space: nowrap;
                  line-height: 1;

                }
              }
            }
          }
        }
      }

      .input_list {
        // display: none;
        width: 100%;
        background: #ffffff;
        box-shadow: 0 0 40px rgba(0, 0, 0, .1);
        border-radius: 24px;
        box-sizing: border-box;
        position: absolute;
        top: 56px;
        left: 0;
        padding: 16px;
        min-height: 200px;

        .input_item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 40px;
          margin-bottom: 4px;
          border-radius: 10px;
          box-sizing: border-box;
          cursor: pointer;

          .search_icon {
            width: 24px;
            height: 24px;
            display: block;
            padding-left: 8px;
          }

          .input_text {
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #333;
            line-height: 20px;
            padding: 0 16px 0 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

        }

        .empty_box {
          font-size: 16px;
          color: #999;
          line-height: 24px;
          padding: 44px 40px 48px;
          margin: 0 auto;
          text-align: center;

          .empty_icon {
            width: 120px;
            height: 100px;
            margin: auto;
            display: block;
          }
        }
      }
    }
  }
}
</style>
